/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmMatchPreviewOutcomeThresholdsUsed } from './MdmMatchPreviewOutcomeThresholdsUsed';
import {
    MdmMatchPreviewOutcomeThresholdsUsedFromJSON,
    MdmMatchPreviewOutcomeThresholdsUsedFromJSONTyped,
    MdmMatchPreviewOutcomeThresholdsUsedToJSON,
    MdmMatchPreviewOutcomeThresholdsUsedToJSONTyped,
} from './MdmMatchPreviewOutcomeThresholdsUsed';
import type { MdmMatchPreviewTierTraceStepDto } from './MdmMatchPreviewTierTraceStepDto';
import {
    MdmMatchPreviewTierTraceStepDtoFromJSON,
    MdmMatchPreviewTierTraceStepDtoFromJSONTyped,
    MdmMatchPreviewTierTraceStepDtoToJSON,
    MdmMatchPreviewTierTraceStepDtoToJSONTyped,
} from './MdmMatchPreviewTierTraceStepDto';
import type { MdmMatchPreviewEntitySummary } from './MdmMatchPreviewEntitySummary';
import {
    MdmMatchPreviewEntitySummaryFromJSON,
    MdmMatchPreviewEntitySummaryFromJSONTyped,
    MdmMatchPreviewEntitySummaryToJSON,
    MdmMatchPreviewEntitySummaryToJSONTyped,
} from './MdmMatchPreviewEntitySummary';
import type { MdmMatchPreviewRuleMatchDetailDto } from './MdmMatchPreviewRuleMatchDetailDto';
import {
    MdmMatchPreviewRuleMatchDetailDtoFromJSON,
    MdmMatchPreviewRuleMatchDetailDtoFromJSONTyped,
    MdmMatchPreviewRuleMatchDetailDtoToJSON,
    MdmMatchPreviewRuleMatchDetailDtoToJSONTyped,
} from './MdmMatchPreviewRuleMatchDetailDto';

/**
 * 
 * @export
 * @interface MdmMatchPreviewResponse
 */
export interface MdmMatchPreviewResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchPreviewResponse
     */
    readOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    entityId1?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    entityId2?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    outcomeBand?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    outcomeLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewResponse
     */
    confidenceScore?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewResponse
     */
    decisiveTier?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchPreviewResponse
     */
    tierShortCircuited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchPreviewResponse
     */
    forceManualReview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchPreviewResponse
     */
    wouldCreateCandidate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchPreviewResponse
     */
    wouldAutoMerge?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMatchPreviewResponse
     */
    matchedRuleIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMatchPreviewResponse
     */
    guardVetoes?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: MdmMatchPreviewRuleMatchDetailDto; }}
     * @memberof MdmMatchPreviewResponse
     */
    matchDetails?: { [key: string]: MdmMatchPreviewRuleMatchDetailDto; };
    /**
     * 
     * @type {MdmMatchPreviewEntitySummary}
     * @memberof MdmMatchPreviewResponse
     */
    entity1Summary?: MdmMatchPreviewEntitySummary;
    /**
     * 
     * @type {MdmMatchPreviewEntitySummary}
     * @memberof MdmMatchPreviewResponse
     */
    entity2Summary?: MdmMatchPreviewEntitySummary;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    policyConfigurationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    policyVersionLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewResponse
     */
    assetClass?: string;
    /**
     * 
     * @type {Array<MdmMatchPreviewTierTraceStepDto>}
     * @memberof MdmMatchPreviewResponse
     */
    tierTrace?: Array<MdmMatchPreviewTierTraceStepDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMatchPreviewResponse
     */
    tierTraceNotes?: Array<string>;
    /**
     * 
     * @type {MdmMatchPreviewOutcomeThresholdsUsed}
     * @memberof MdmMatchPreviewResponse
     */
    thresholdsUsed?: MdmMatchPreviewOutcomeThresholdsUsed;
}

/**
 * Check if a given object implements the MdmMatchPreviewResponse interface.
 */
export function instanceOfMdmMatchPreviewResponse(value: object): value is MdmMatchPreviewResponse {
    return true;
}

export function MdmMatchPreviewResponseFromJSON(json: any): MdmMatchPreviewResponse {
    return MdmMatchPreviewResponseFromJSONTyped(json, false);
}

export function MdmMatchPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'readOnly': json['readOnly'] == null ? undefined : json['readOnly'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId1': json['entityId1'] == null ? undefined : json['entityId1'],
        'entityId2': json['entityId2'] == null ? undefined : json['entityId2'],
        'outcomeBand': json['outcomeBand'] == null ? undefined : json['outcomeBand'],
        'outcomeLabel': json['outcomeLabel'] == null ? undefined : json['outcomeLabel'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'decisiveTier': json['decisiveTier'] == null ? undefined : json['decisiveTier'],
        'tierShortCircuited': json['tierShortCircuited'] == null ? undefined : json['tierShortCircuited'],
        'forceManualReview': json['forceManualReview'] == null ? undefined : json['forceManualReview'],
        'wouldCreateCandidate': json['wouldCreateCandidate'] == null ? undefined : json['wouldCreateCandidate'],
        'wouldAutoMerge': json['wouldAutoMerge'] == null ? undefined : json['wouldAutoMerge'],
        'matchedRuleIds': json['matchedRuleIds'] == null ? undefined : json['matchedRuleIds'],
        'guardVetoes': json['guardVetoes'] == null ? undefined : json['guardVetoes'],
        'matchDetails': json['matchDetails'] == null ? undefined : (mapValues(json['matchDetails'], MdmMatchPreviewRuleMatchDetailDtoFromJSON)),
        'entity1Summary': json['entity1Summary'] == null ? undefined : MdmMatchPreviewEntitySummaryFromJSON(json['entity1Summary']),
        'entity2Summary': json['entity2Summary'] == null ? undefined : MdmMatchPreviewEntitySummaryFromJSON(json['entity2Summary']),
        'policyConfigurationId': json['policyConfigurationId'] == null ? undefined : json['policyConfigurationId'],
        'policyVersionLabel': json['policyVersionLabel'] == null ? undefined : json['policyVersionLabel'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'tierTrace': json['tierTrace'] == null ? undefined : ((json['tierTrace'] as Array<any>).map(MdmMatchPreviewTierTraceStepDtoFromJSON)),
        'tierTraceNotes': json['tierTraceNotes'] == null ? undefined : json['tierTraceNotes'],
        'thresholdsUsed': json['thresholdsUsed'] == null ? undefined : MdmMatchPreviewOutcomeThresholdsUsedFromJSON(json['thresholdsUsed']),
    };
}

export function MdmMatchPreviewResponseToJSON(json: any): MdmMatchPreviewResponse {
    return MdmMatchPreviewResponseToJSONTyped(json, false);
}

export function MdmMatchPreviewResponseToJSONTyped(value?: MdmMatchPreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'readOnly': value['readOnly'],
        'entityType': value['entityType'],
        'entityId1': value['entityId1'],
        'entityId2': value['entityId2'],
        'outcomeBand': value['outcomeBand'],
        'outcomeLabel': value['outcomeLabel'],
        'confidenceScore': value['confidenceScore'],
        'decisiveTier': value['decisiveTier'],
        'tierShortCircuited': value['tierShortCircuited'],
        'forceManualReview': value['forceManualReview'],
        'wouldCreateCandidate': value['wouldCreateCandidate'],
        'wouldAutoMerge': value['wouldAutoMerge'],
        'matchedRuleIds': value['matchedRuleIds'],
        'guardVetoes': value['guardVetoes'],
        'matchDetails': value['matchDetails'] == null ? undefined : (mapValues(value['matchDetails'], MdmMatchPreviewRuleMatchDetailDtoToJSON)),
        'entity1Summary': MdmMatchPreviewEntitySummaryToJSON(value['entity1Summary']),
        'entity2Summary': MdmMatchPreviewEntitySummaryToJSON(value['entity2Summary']),
        'policyConfigurationId': value['policyConfigurationId'],
        'policyVersionLabel': value['policyVersionLabel'],
        'assetClass': value['assetClass'],
        'tierTrace': value['tierTrace'] == null ? undefined : ((value['tierTrace'] as Array<any>).map(MdmMatchPreviewTierTraceStepDtoToJSON)),
        'tierTraceNotes': value['tierTraceNotes'],
        'thresholdsUsed': MdmMatchPreviewOutcomeThresholdsUsedToJSON(value['thresholdsUsed']),
    };
}

